import { Icon } from "@vds/icons";
import Pagination from "react-js-pagination";
import * as StyledPaginationCSS from "../../constants/common/StyledPaginationConstants";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

function PageAlignment({ activePage, recordsPerPage, totalNumberOfRecords, pageRangeDisplayed, handlePageChange }) {
  const { t } = useTranslation("casesTranslation");
  return (
    <StyledPaginationCSS.BillingBottom className="pagination" role="navigation" aria-label="pagination">
      <StyledPaginationCSS.RightDiv>
        <Icon
          id="support-page-left-arrow"
          name="left-arrow"
          size="small"
          color="#000000"
          style={{ fontWeight: "bold" }}
          backgroundColor="transparent"
          aria-hidden="true"
          tabIndex={-1}
        />
        <Pagination
          id="cfst-appt-list-pagination"
          activePage={activePage}
          itemsCountPerPage={recordsPerPage}
          totalItemsCount={totalNumberOfRecords}
          pageRangeDisplayed={pageRangeDisplayed}
          onChange={handlePageChange}
          prevPageText={t("Previous")}
          nextPageText={t("Next")}
          hideFirstLastPages={true}
          itemClassPrev="firstPage"
          itemClassNext="nextPage"
        />
        <Icon
          id="support-page-right-arrow"
          name="right-arrow"
          size="small"
          color="#000000"
          style={{ fontWeight: "bold" }}
          backgroundColor="transparent"
          aria-hidden="true"
          tabIndex={-1}
        />
      </StyledPaginationCSS.RightDiv>
    </StyledPaginationCSS.BillingBottom>
  );
}

PageAlignment.propTypes = {
  activePage: PropTypes.number.isRequired,
  recordsPerPage: PropTypes.number.isRequired,
  totalNumberOfRecords: PropTypes.number.isRequired,
  pageRangeDisplayed: PropTypes.number.isRequired,
  handlePageChange: PropTypes.func.isRequired,
};

export default PageAlignment;
